/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Remove_SelectedInputs */

const en_general_remove_selected = /** @type {(inputs: General_Remove_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove selected items`)
};

const de_general_remove_selected = /** @type {(inputs: General_Remove_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Elemente entfernen`)
};

/**
* | output |
* | --- |
* | "Remove selected items" |
*
* @param {General_Remove_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_remove_selected = /** @type {((inputs?: General_Remove_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Remove_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_remove_selected(inputs)
	return de_general_remove_selected(inputs)
});